import { ElMessage } from 'element-plus';

export const wakeWordText = [
  '你好洋河',
  '你好阳光',
  '你好羊和',
  '你好养活',
  '你好扬合',
  '你好样货',
  '你好洋货',
  '你好杨鹤',
  '你好杨河',
  '你好阳和',
  '你好阳货',
  '你好扬和',
  '你好杨和',
  '你好杨合',
  '你好杨贺',
  '你好杨鹤',
  '你好杨火',
  '你好杨盒',
  '你好杨获',
  '您好洋河',
  '您好阳光',
  '您好羊和',
  '您好养活',
  '您好扬合',
  '您好样货',
  '您好洋货',
  '您好杨鹤',
  '您好杨河',
  '您好阳和',
  '您好阳货',
  '您好扬和',
  '您好杨和',
  '您好杨合',
  '您好杨贺',
  '您好杨鹤',
  '您好杨火',
  '您好杨盒',
  '您好杨获',
];

export const wakeWordSymbol = [',', '.', '，', '。', '，', '。'];

// 校验唤醒词是否正确
export let validateWakeWord = (wakeWords) => {
  // 构建正则表达式
  const wordPattern = wakeWordText.map((word) => word.split('').join(`(?:[${wakeWordSymbol.join('')}])?`)).join('|');
  const regex = new RegExp(`(?:${wordPattern})`);
  // 测试函数
  function containsHelloYangHe(text) {
    return regex.test(text);
  }
  return containsHelloYangHe(wakeWords);
};

export let getStatusKey = (statusKey = '') => {
  // 根据状态数字判断当前状态
  if (['TextOver', 'Initial'].includes(statusKey)) {
    return 'readyToSpeak';
  } else if (['TextStart', 'SentenceStart'].includes(statusKey)) {
    return 'mute';
  } else {
    return 'speaking'; // 保留原来的默认返回值
  }
};

// 关键词映射表
export const keywordMap = {
  爆装: '报装',
  包装: '报装',
  杨河: '杨和',
  映和: '杨和',
  阳荷: '杨和',
  扬河: '杨和',
  扬和: '杨和',
  扬合: '杨和',
  羊合: '杨和',
  羊河: '杨和',
  羊和: '杨和',
  洋何: '杨和',
  洋河: '杨和',
  洋和: '杨和',
  合企: '和企',
  合体: '和企',
  合起: '和企',
  和起: '和企',
  和体: '和企',
  何企: '和企',
  何起: '和企',
};

// 关键词校正函数
export function correctKeywords(text = '') {
  // 移除所有符号
  const cleanedText = text.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '');
  // 替换关键词
  let correctedText = cleanedText;
  for (const [key, value] of Object.entries(keywordMap)) {
    const regex = new RegExp(key, 'g');
    correctedText = correctedText.replace(regex, value);
  }

  return correctedText || text;
}
